const navLists = [
  {
    id: 1,
    name: "Booking Report - Summary",
    url: "/booking-summary",
  },
  {
    id: 2,
    name: "Transaction Hourly",
    url: "/transaction-hourly",
  },
  {
    id: 3,
    name: "Cinemawise Sales Summary",
    url: "/cinema-wise-sales",
  },
  {
    id: 4,
    name: "Moviewise - Summary",
    url: "/movie-wise-sales",
  },
  {
    id: 5,
    name: "Sales Report",
    url: "/sales-summary",
  },
  // {
  //   id: 6,
  //   name: "Complimentary Report",
  //   url: "/booking-summary",
  // },
  {
    id: 7,
    name: "Schedule Report",
    url: "/schedule-report",
  },
  {
    id: 8,
    name: "FB Sale Summary",
    url: "/fb-sale-summary",
  },
  {
    id: 9,
    name: "Occupancy Report",
    url: "/occupancy-report",
  },
  {
    id: 9,
    name: "Week Wise Movie History",
    url: "/week-wise-movie-history",
  },
  {
    id: 10,
    name: "Movie Summary Report",
    url: "/movie-summary-report",
  },
  // {
  //   id: 10,
  //   name: "Occupancy Report",
  //   url: "/booking-summary",
  // },
];

export default navLists;



// WEBPACK FOOTER //
// ./src/helper/navLists.js